import styled from 'styled-components';
import { Text, CTAButton, BgVideo } from '../../components/core';
import WelcomeCompanyLogo from '../../assets/welcome-company-logo.svg';
import { createRef, useEffect, useState } from 'react';
import Theme from '../../Theme';
import { assetsPath } from '../../other/constants';

const WelcomeContainer = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  display: flex;
  align-items: center;
  z-index: 1;
`;

const WelcomeContent = styled.div`
  width: 66%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  @media screen  and (max-width:${Theme.devices.mobile}),(max-height:${Theme.devices.mobile}){
    width: auto;
  }

  .header-container {
    margin-bottom: 10px;
    width: 63%;
    max-width: 480px;
    margin-left: 280px;
    margin-right: auto;
    @media screen  and (max-width:${Theme.devices.mobile}),(max-height:${Theme.devices.mobile}){
      margin-left: 20px;
    }
    
    img {
      margin-left: -8px;
      @media screen  and (max-width:${Theme.devices.mobile}),(max-height:${Theme.devices.mobile}){
        margin-left: 0px;
        max-width: 100%;
      }
      
    }
  }

  .white-line {
    width: 0%;
    border: 1px solid white;
    height: 1px;
    margin-bottom: 22px;
    margin-right: auto;
  }

  .body-container {
    width: 63%;
    margin-bottom: 40px;
    margin-left: 280px;
    margin-right: auto;
    max-width: 480px;
    @media screen  and (max-width:${Theme.devices.mobile}),(max-height:${Theme.devices.mobile}){
      width: auto;
      margin-bottom: 20px;
      margin-left: 20px;
      margin-right: 20px;
    }
  }

  .button-container {
    width: 63%;
    max-width: 480px;
    margin-left: 280px;
    margin-right: auto;
    
    @media screen  and (max-width:${Theme.devices.mobile}),(max-height:${Theme.devices.mobile}){
      margin-left: 20px;
    }
  }
`;

type Props = {
  enterSite: () => void
  enter: boolean
}

const WelcomeScreen = ({ enterSite, enter }: Props) => {

  const ref = createRef<HTMLDivElement>()
  const [remove, setRemove] = useState(false)

  useEffect(() => {

    (async () => {
      if (!enter) await setRemove(false)

      ref.current?.animate([
        { opacity: enter ? 1 : 0 },
        { opacity: enter ? 0 : 1 }
      ], {
        duration: 1000,
        easing: "ease-in-out"
      });

      if (enter) setTimeout(() => setRemove(true), 1000)
    })()

  }, [enter])

  if (remove) return null

  return (
    <WelcomeContainer ref={ref}>
      <BgVideo src={`${assetsPath}landing.mp4`} darkOverlay={0.3} />
      <WelcomeContent>
        <div className='header-container fadeInUp'>
          <img src={WelcomeCompanyLogo} alt='company logo' />
        </div>
        <div className='white-line growFull'></div>
        <div className='body-container fadeInUpDelay'>
          <Text variant='Body3'>Let us take you on a virtual tour of our state-of-the-art training centre. On this tour you’ll be able to move at your own pace, pause the video, and view the spaces in 360 video. Ready to start?</Text>
        </div>
        <div className='button-container fadeInUpDelay'>
          <CTAButton onClick={enterSite} variant='solid'>ENTER</CTAButton>
        </div>
      </WelcomeContent>
    </WelcomeContainer>
  );
};

export default WelcomeScreen;